import React from 'react';
import { string, func, oneOfType, number, bool } from 'prop-types';

import { Container } from './styles';

function HoverButton({
  label,
  disabled,
  onClick,
  margin,
  padding,
  width,
  small,
  background,
  color,
  ...rest
}) {
  return (
    <Container
      onClick={!disabled ? onClick : null}
      disabled={disabled}
      margin={margin}
      padding={padding}
      width={width}
      small={small}
      background={background}
      color={color}
      {...rest}
    >
      {label}
    </Container>
  );
}

HoverButton.propTypes = {
  label: string,
  onClick: func,
  disabled: bool,
  margin: oneOfType([string, number]),
  padding: string,
  width: string,
  small: bool,
  background: string,
  color: string,
};

HoverButton.defaultProps = {
  label: '',
  disabled: false,
  onClick: () => {},
  margin: '0.2rem 0',
  padding: '0 9rem',
  width: '100%',
  small: false,
  background: 'blue',
  color: 'white',
};

export default HoverButton;
